import { conferenceJoined, conferenceLeft, conferenceTimestampChanged, setConferenceError } from "../../features/base/conference";
import { connectionDisconnect } from "../../features/base/connection";
import { JitsiConferenceErrors, JitsiConferenceEvents } from "../../features/base/lib-jitsi-meet";
import { VIDEO_TYPE } from "../../features/base/media";
import { dominantSpeakerChanged, getMemberIdByJitisiId } from "../../features/base/participants";
import { trackRemoved } from "../../features/base/tracks";
import { endpointMessageReceived } from "../../features/chat";

class RoomListener {
    constructor() {
        this.conference = null;
        this.deviceManager = null;
    }

    init(conference, deviceManager) {
        this.conference = conference;
        this.deviceManager = deviceManager;

        this._handlerRoomEvent();
    }

    _handlerRoomEvent() {
        const { dispatch, getState } = APP.store;
        const state = getState();
        const deviceManager = this.deviceManager;

        // 방 입장 
        this.conference.on(JitsiConferenceEvents.CONFERENCE_JOINED, () => {
            const data = {
                conference: this.conference,
                e2eeSupported: this.conference.isE2EESupported(),
                joined: undefined,
                leaving: undefined
            };

            dispatch(conferenceJoined(data, APP.mateOption.mediaServer));
        });

        // 방 입장 실패
        this.conference.on(JitsiConferenceEvents.CONFERENCE_FAILED, e => {
            dispatch(connectionDisconnect("jitsi"));
            if (e === "conference.videobridgeNotAvailable") e = JitsiConferenceErrors.VIDEOBRIDGE_NOT_AVAILABLE;
            dispatch(setConferenceError(e));
        });

        // 회의 나가기
        this.conference.on(JitsiConferenceEvents.CONFERENCE_LEFT, (...args) => {
            dispatch(conferenceTimestampChanged(0));
            dispatch(conferenceLeft(this.conference, ...args));
        });

        // 사용자 track 
        this.conference.on(JitsiConferenceEvents.TRACK_ADDED, track => {
            if (!track || track.isLocal()) {
                return;
            }
            

            deviceManager.trackAdded(track);
        });
        // 사용자 track 삭제 
        this.conference.on(JitsiConferenceEvents.TRACK_REMOVED, track => {
            if (!track || track.isLocal()) {
                return;
            }
            dispatch(trackRemoved(track));
        });

        
        // this.conference.on(JitsiConferenceEvents.ENDPOINT_MESSAGE_RECEIVED, (...args) => { 
        //     if (args && args.length >= 2) {
        //         const [ eventData ] = args;

        //         if (eventData.name !== 'endpoint-text-message') {
        //             dispatch(endpointMessageReceived(...args));
        //         }
        //     }
        // });

        this.conference.on(JitsiConferenceEvents.DOMINANT_SPEAKER_CHANGED, id => {
            const user_uuid = getMemberIdByJitisiId(state, id);

            dispatch(dominantSpeakerChanged(user_uuid));
        });

        // 회의 입장 시간 변경 
        this.conference.on(JitsiConferenceEvents.CONFERENCE_CREATED_TIMESTAMP, conferenceTimestamp => 
            dispatch(conferenceTimestampChanged(conferenceTimestamp))
        );  
    }
    
}

const roomListener = new RoomListener();
export default roomListener;